module.exports = __webpack_public_path__ + "media/audio87.4e808b3d.mp3";